import { render, staticRenderFns } from "./newPremiumOffers.vue?vue&type=template&id=7b1f98b9&"
import script from "./newPremiumOffers.vue?vue&type=script&lang=js&"
export * from "./newPremiumOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports